import { InvestmentDetailsCardStyles } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/InvestmentDetails/components/InvestmentDetailsCard/InvestmentDetailsCard.styles.tsx';
import { Flex, Text } from '@mantine/core';
import { ReactNode } from 'react';

interface Props {
	cardLabel?: string;
	cardLabelComponent?: ReactNode;
	labelAfter?: ReactNode;
	variant?: 'bordered' | 'borderless';
	children: ReactNode;
	actions?: ReactNode;
}

export const InvestmentDetailsCard = ({
	cardLabel,
	cardLabelComponent,
	labelAfter,
	variant = 'bordered',
	children,
	actions,
}: Props) => (
	<InvestmentDetailsCardStyles className={variant}>
		<Flex justify="space-between" align="center" className="header">
			<Flex align="center">
				{cardLabel && (
					<Text fz={12} fw={600} c="gray.9" tt="uppercase" className="label">
						{cardLabel}
					</Text>
				)}

				{cardLabelComponent}

				{labelAfter}
			</Flex>

			{actions && (
				<Flex align="center" gap="0.5rem">
					{actions}
				</Flex>
			)}
		</Flex>

		<div className="content">{children}</div>
	</InvestmentDetailsCardStyles>
);
